import React from 'react';
import PropTypes from 'prop-types';
import ReactDrawer from 'react-toolbox/lib/drawer';

const Drawer = ({ active, handleToggle, children }) => (
  <ReactDrawer
    active={active}
    onOverlayClick={handleToggle}
    type="right"
    style={{ flex: '0 0 24em' }}
  >
    {children}
  </ReactDrawer>
);

Drawer.propTypes = {
  active: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/App/events/components/Drawer.js